import { bunja } from 'bunja';

import { r230522SocketBunja } from './socket';

// context: https://prextech.slack.com/archives/CSJUWFLAG/p1731649392695179
export const tickersBunja = bunja(() => {
  const { r230522Socket } = bunja.use(r230522SocketBunja);
  type Ticker = string | null;
  let currentPswapTicker: Ticker = null;
  let currentSpotTicker: Ticker = null;

  function getCurrentTicker() {
    return currentPswapTicker || currentSpotTicker;
  }

  function updateSubs() {
    r230522Socket.send({ s: { tickers: getCurrentTicker() } });
  }

  function safeUpdate(newTicker: Ticker, setFn: (newTicker: Ticker) => void) {
    const oldTicker = getCurrentTicker();
    setFn(newTicker);
    if (oldTicker !== newTicker) updateSubs();
  }

  function setCurrentPswapTicker(ticker: Ticker = null) {
    safeUpdate(ticker, () => {
      currentPswapTicker = ticker;
      currentSpotTicker = null;
    });
  }

  function setCurrentSpotTicker(ticker: Ticker = null) {
    safeUpdate(ticker, () => {
      currentSpotTicker = ticker;
      currentPswapTicker = null;
    });
  }

  bunja.effect(() => {
    updateSubs();
    r230522Socket.on('connected', updateSubs);

    return () => {
      updateSubs();
      r230522Socket.off('connected', updateSubs);
    };
  });

  return {
    setCurrentPswapTicker,
    setCurrentSpotTicker,
  };
});
tickersBunja.debugLabel = 'tickersBunja';
